import MUIIconButton from '@material-ui/core/IconButton';

const IconButton = ({ children, ...otherProps }) => (
  <MUIIconButton {...otherProps}>{children}</MUIIconButton>
)

export default IconButton